/* CARELIKA 2026 - adds a search field and quick links to the mobile menu drawer (theme copy only). */
(function () {
  function enhance() {
    var links = document.querySelector('.sf-menu-wrapper-mobile .sf-menu-links');
    if (!links || links.querySelector('.ck-msearch')) return;
    var form = document.createElement('form');
    form.className = 'ck-msearch';
    form.action = '/search';
    form.setAttribute('role', 'search');
    form.innerHTML = '<input type="search" name="q" placeholder="Search products, peels, protocols" aria-label="Search CARELIKA"><button type="submit">Search</button>';
    var hint = document.createElement('p');
    hint.className = 'ck-mhint';
    hint.textContent = 'Popular: Amber Carboxy Therapy · Peels · Sterile cocktails · Filler Elegance';
    links.insertBefore(hint, links.firstChild);
    links.insertBefore(form, hint);
    var quick = document.createElement('div');
    quick.className = 'ck-mquick';
    quick.innerHTML = '<a href="/pages/carelika-in-the-world">Find a clinic</a><a href="/pages/skin-test">Skin test</a><a href="/pages/contact">Contact</a><a href="https://www.instagram.com/carelikaprofessional/" rel="noopener" target="_blank">Instagram</a>';
    links.appendChild(quick);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance); else enhance();
})();
